import React, { useState, useEffect, useRef } from "react";
import { useChat } from "./useChat";
import { Button } from "react-bootstrap";
import "./Chat.css";
import { FaPaperPlane } from "react-icons/fa";
import { BsChatDots } from "react-icons/bs";
export default function ChatWidget() {
    const [open, setOpen] = useState(false);
    const [input, setInput] = useState("");
    const [hasStartedChat, setHasStartedChat] = useState(false);

    const { messages, sendMessage, isLoading } = useChat();
    const bottomRef = useRef(null);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({ behavior: "smooth" });
    }, [messages]);

    const renderTypingLoader = () => {
        return (
            <div className="msg bot typing">
                <div className="dot"></div>
                <div className="dot"></div>
                <div className="dot"></div>
                 <div>AI is typing</div>
            </div>
        );
    };

    const handleSend = () => {
        if (input.trim() === "") return;
        setHasStartedChat(true); 
        sendMessage(input);
        setInput("");
    };

    return (
        <>
            {/* Chat Button */}
            {!open && (
                <div className="chat-btn bg-primary" onClick={() => setOpen(true)}>
                    <span className="chat-icon"><BsChatDots/></span>
                </div>
            )}

            {/* Chat Sidebar */}
            <div className={`chat-sidebar ${open ? "open" : ""}`}>
                {/* Header */}
                <div className="chat-header">
                    <span className="d-block text-center fw-bold">AI Chat</span>
                    <button
                        onClick={() => {
                            setOpen(false);
                            setHasStartedChat(false); // reset
                        }}
                        className="close-btn"
                    >
                        ✖
                    </button>
                </div>

                {/* Body */}
                <div className="chat-body">
                    {!hasStartedChat ? (
                        <div className="welcome-screen">
                            <div className="welcome-icon">🤖</div>
                            <h3>Welcome to AI Chat</h3>
                            <p>
                                Start a conversation with your intelligent assistant.
                                Ask questions, get help, or just chat!
                            </p>
                        </div>
                    ) : (
                        <>
                            {messages.map((msg) => (
                                <div
                                    key={msg.id}
                                    className={`msg-row ${msg.isUser ? "user-row" : "bot-row"}`}
                                >
                                    {/* BOT SIDE */}
                                    {!msg.isUser && (
                                        <>
                                            <div className="bot-icon">🤖</div> 
                                            <div className="msg bot">{msg.content}</div>
                                        </>
                                    )}
                                    {msg.isUser && (
                                        <>
                                            <div className="msg user">{msg.content}</div>
                                            <div className="user-icon">👤</div>
                                        </>
                                    )}
                                </div>
                            ))}

                            {isLoading && renderTypingLoader()}
                            <div ref={bottomRef}></div>
                        </>
                    )}
                </div>

                {/* Input */}
                <div className="chat-input">
                    <input
                        value={input}
                        onChange={(e) => setInput(e.target.value)}
                        placeholder="Type message..."
                        onKeyDown={(e) => e.key === "Enter" && handleSend()}
                    />
                    <Button variant="primary" onClick={handleSend}>
                        <FaPaperPlane />
                    </Button>
                </div>
            </div>
        </>
    );
}